import { apiClient } from '../lib/apiClient';
import type { Paginated } from './catalog';

/** 审计日志的一行（`04-api-contract.md` §24.1） */
export interface AuditLogView {
  id: string;
  actorType: string;
  actorId: string | null;
  /** 稳定动作名，如 `stock.adjust` / `stock.transfer.create` */
  action: string;
  targetType: string;
  targetId: string | null;
  /** 状态快照而非 diff：读者要能独立看懂一条记录 */
  before: unknown;
  after: unknown;
  deviceId: string | null;
  createdAt: string;
}

/** `GET /audit-logs` 的筛选与分页参数 */
export interface AuditLogQuery {
  action?: string;
  targetType?: string;
  actorType?: string;
  from?: string;
  to?: string;
  page?: number;
  pageSize?: number;
}

/**
 * 审计日志查询（`04-api-contract.md` §24）。
 *
 * **只有 `list`**：契约里不存在任何写端点——日志只能由服务端在业务事务内追加，
 * 前端连「可能写」的方法都不该有，免得后来者以为删一条只是一次调用的事。
 */
export const auditApi = {
  list: (params: AuditLogQuery = {}) =>
    apiClient.get<Paginated<AuditLogView>>('/audit-logs', { params }),
};
